module.exports = __webpack_public_path__ + "static/media/linkedin.cceaf055.svg";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/FooterSection/linkedin.svg
// module id = 1085
// module chunks = 1